export enum CartItemAvailabilityStatusEnum {
	Available = 'available',
	OutOfStock = 'out-of-stock',
	Unavailable = 'unavailable',
}
